export default __webpack_public_path__ + "static/media/movie-buddy.2244655b.png";